import React from "react";

export default function Logo({ fill }) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      height="35px"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={fill}
        stroke="none"
      >
        <path
          d="M153 4284 c28 -42 69 -98 90 -125 21 -27 63 -86 95 -132 31 -45 77
-110 102 -144 l45 -62 892 -1 c885 0 892 0 898 -20 4 -11 5 -92 4 -179 l-3
-159 44 -68 c24 -38 50 -80 59 -93 9 -13 21 -31 26 -40 6 -8 33 -52 61 -96 28
-44 59 -95 70 -112 10 -18 21 -33 24 -33 3 0 14 15 24 33 11 17 42 68 70 112
28 44 56 88 61 96 6 9 17 27 26 40 9 13 36 55 60 94 l44 69 0 176 0 175 895 3
895 3 45 62 c25 34 76 106 115 160 38 54 85 119 103 145 18 25 53 74 77 109
l44 63 -2459 0 -2459 0 52 -76z"
        />
        <path
          d="M690 3525 c0 -7 88 -135 110 -160 10 -11 47 -61 82 -112 34 -50 89
-128 121 -172 l58 -81 105 0 104 0 0 -677 1 -678 129 -145 c71 -80 237 -266
368 -415 132 -148 249 -279 261 -289 l21 -19 0 393 0 393 -57 66 c-31 36 -78
89 -105 116 l-48 51 2 594 3 594 118 -150 c64 -82 151 -192 192 -244 41 -52
112 -142 157 -199 46 -58 118 -151 161 -208 43 -57 82 -103 87 -103 5 0 44 46
87 103 43 57 115 150 161 208 45 57 116 147 157 199 41 52 112 142 157 199 46
58 99 125 118 150 l35 46 3 -595 2 -594 -48 -51 c-27 -27 -74 -80 -105 -116
l-57 -66 0 -393 0 -393 21 19 c12 10 116 127 232 259 116 132 236 267 268 300
31 33 102 112 158 175 l100 115 1 678 0 677 104 0 105 0 58 81 c32 44 90 125
128 179 39 54 96 135 128 178 31 44 57 83 57 86 0 3 -321 6 -713 6 l-713 0
-60 -92 c-32 -50 -61 -96 -63 -102 -2 -5 -22 -38 -45 -73 -23 -34 -61 -95 -86
-134 -25 -39 -70 -110 -100 -158 -30 -47 -61 -98 -69 -113 -8 -16 -17 -28 -21
-28 -4 0 -13 12 -21 28 -8 15 -38 65 -68 112 -30 47 -75 118 -100 158 -25 40
-65 102 -88 138 -24 35 -43 67 -43 69 0 3 -28 48 -62 100 l-62 95 -713 0
c-392 0 -713 -2 -713 -5z"
        />
        <path
          d="M2275 1530 l0 -740 285 0 285 0 0 740 c0 407 -2 740 -5 739 -3 0 -38
-44 -78 -97 -129 -171 -191 -247 -202 -247 -11 0 -73 76 -202 247 -40 53 -75
97 -78 97 -3 1 -5 -332 -5 -739z"
        />
      </g>
    </svg>
  );
}
